// Pressed keys (bottom left), like the keypress display of DeFRaG / Momentum.

import { el } from './dom';

export const KEY_FORWARD = 1;
export const KEY_BACK = 2;
export const KEY_LEFT = 4;
export const KEY_RIGHT = 8;
export const KEY_JUMP = 16;
export const KEY_CROUCH = 32;
export const KEY_SPRINT = 64;
export const KEY_PRONE = 128;

const LAYOUT: [number, string, string][] = [
  [KEY_FORWARD, 'W', 'k-fwd'],
  [KEY_LEFT, 'A', 'k-left'],
  [KEY_BACK, 'S', 'k-back'],
  [KEY_RIGHT, 'D', 'k-right'],
  [KEY_JUMP, 'JUMP', 'k-jump'],
  [KEY_CROUCH, 'CROUCH', 'k-crouch'],
  [KEY_SPRINT, 'SPRINT', 'k-sprint'],
  [KEY_PRONE, 'PRONE', 'k-prone'],
];

export class Keys {
  readonly root = el('div', 'hud-keys');
  private readonly cells: [number, HTMLElement][] = [];
  private last = -1;

  constructor() {
    for (const [bit, label, cls] of LAYOUT) {
      const cell = el('div', `hud-key ${cls}`, label);
      this.cells.push([bit, cell]);
      this.root.appendChild(cell);
    }
  }

  update(mask: number): void {
    if (mask === this.last) return;
    this.last = mask;
    for (const [bit, cell] of this.cells) cell.classList.toggle('on', (mask & bit) !== 0);
  }
}
